import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Input, Modal, Header } from "semantic-ui-react";
import { CheckList } from "../../../../../../../models/checklist-model";
import { faTimes } from "@fortawesome/pro-light-svg-icons";
import TaskModel from "../../../../../../../models/responses/task.model";
import TaskStatusModel from "../../../../../../../models/responses/task-status.model";
import {
  useUserAsMemberForActiveProjectSelector,
  useUserSelector,
} from "../../../../../../../store/selectors/authorization.selectors";
import { useTypedSelector } from "../../../../../../../store/selectors/selectors.utils";
import { GateKeeperEum } from "../../../../../../../models/gate-keeper.enum";
import NewChecklistModal from "../../../../ChecklistPage/components/NewChecklistModal";

interface InjectedProps {
  isChecklistOpened: boolean;
  setIsChecklistOpened: React.Dispatch<React.SetStateAction<boolean>>;
  isLockOpened: boolean;
  setIsLockOpened: React.Dispatch<React.SetStateAction<boolean>>;
  taskChecklist: CheckList[];
  addChecklistHandler: () => void;
  addImportedChecklistHandler: () => void;
  lockChecklist: () => void;
  inputValue: string;
  setInputValue: React.Dispatch<React.SetStateAction<string>>;
  inputRef: React.MutableRefObject<any>;
  activeTask: TaskModel;
  disabled: boolean;
}

const TaskAddChecklist: React.FC<InjectedProps> = ({
  isChecklistOpened,
  setIsChecklistOpened,
  isLockOpened,
  setIsLockOpened,
  taskChecklist,
  addChecklistHandler,
  addImportedChecklistHandler,
  lockChecklist,
  inputValue,
  setInputValue,
  inputRef,
  activeTask,
  disabled
}) => {
  const allChecked: boolean = Array.isArray(activeTask.checklist)
    ? activeTask.checklist.every((el) => el.isChecked)
    : false;
  const user = useUserSelector();
  const activeProject = useTypedSelector(
    (state) => state.project.activeProject
  );
  const userAsMember = activeProject
    ? useUserAsMemberForActiveProjectSelector()
    : null;
  const [openChecklistModal, setOpenChecklistModal] = React.useState(false);

  return (
    <>
      {!isChecklistOpened && (
        <div className="checklist-option">
            <Button
              className="add-checklist"
              onClick={() => setOpenChecklistModal(true)}
              disabled={disabled}
            >
              {activeTask.checklistId ? 'Change checklist' : 'Assign checklist'}
            </Button>
        </div>
      )}

      {openChecklistModal && <NewChecklistModal
          isOpen={openChecklistModal}
          setOpen={setOpenChecklistModal}
          clientId={activeProject!.clientId!}
          taskId={activeTask.task_id}
          activeChecklistId={activeTask.checklistId || null}
      />}
    </>
  );
};

export default TaskAddChecklist;
